export default "__VITE_ASSET__RkJzTFlC__"